import type { FC } from 'react';
import { useIntl } from 'react-intl';

import type { Company } from '@xing-com/crate-common-graphql-types';
import { spaceXL } from '@xing-com/tokens';

import { TopCompanyCard } from '../../../../components/top-company-card/top-company-card';
import { useTopCompanies } from '../../../../hooks/use-top-companies/use-top-companies';
import { createTopCompanies } from '../../../../models/top-companies';
import * as Styled from './top-companies-section.styles';

const LIMIT = 10;

const CustomHeader = () => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <Styled.Title size="small" noMargin>
        {formatMessage({ id: 'CP_TOP_COMPANIES_SECTION_TITLE' })}
      </Styled.Title>
      <Styled.Subtitle sizeConfined="large">
        {formatMessage({ id: 'CP_TOP_COMPANIES_SECTION_SUBTITLE' })}
      </Styled.Subtitle>
    </div>
  );
};

export const TopCompaniesSection: FC = () => {
  const { data, loading } = useTopCompanies({
    limit: LIMIT,
    offset: 0,
  });

  const collection = data?.topCompanies?.collection ?? [];

  const companies = collection
    .map((item) => item?.company)
    .filter((company) => company) as Company[];

  const topCompanies = createTopCompanies(companies);

  return (
    <div data-testid="top-companies-section">
      <Styled.CarouselSection
        variant="custom"
        headerElement={<CustomHeader />}
        useFullWidth
        itemWidthConfined={'368px'}
        itemWidthWide={'368px'}
        paddingBottom={spaceXL}
        paddingTop={spaceXL}
      >
        {loading
          ? Array.from({ length: LIMIT }, (_, index) => (
              <TopCompanyCard.Skeleton key={index} />
            ))
          : topCompanies?.map(
              (company) =>
                company && <TopCompanyCard key={company?.id} item={company} />
            )}
      </Styled.CarouselSection>
    </div>
  );
};
